import SingleChatV2 from './SingleChatV2';

export default SingleChatV2;
